module.exports = __webpack_public_path__ + "img/devices.210aa9d4.svg";